'use client';

import { FeatureEasterEggGame } from '@/features/FeatureEasterEggGame';
import Error from 'next/error';

export default function NotFound() {
	return (
		<div>
			<Error statusCode={404} />
			<FeatureEasterEggGame />
		</div>
	);
}
